var _path, _rect, _path2, _rect2, _path3, _rect3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsappVoice = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#54CF60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#54CF60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L4.56542 9.94677C4.21585 9.34411 4.03247 8.6616 4.03438 7.96388C4.03438 5.77757 5.82235 4 8.01719 4C9.08309 4 10.084 4.41255 10.8348 5.1616C11.5874 5.91065 12.0019 6.90684 12 7.96578C12 10.1521 10.212 11.9297 8.01528 11.9297H8.01337C7.3467 11.9297 6.6915 11.7624 6.10888 11.4468L4 12ZM6.21012 10.73L6.33047 10.8023C6.83858 11.1027 7.4212 11.2605 8.01528 11.2624H8.01719C9.84145 11.2624 11.3276 9.78517 11.3276 7.96768C11.3276 7.08745 10.9838 6.26046 10.3591 5.63688C9.73447 5.01331 8.90162 4.6711 8.01719 4.6711C6.19293 4.6692 4.70678 6.14639 4.70678 7.96388C4.70678 8.58555 4.88061 9.19202 5.21299 9.71673L5.29131 9.84221L4.95702 11.057L6.21012 10.73Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8999,
    y: 7,
    width: 0.75,
    height: 2,
    rx: 0.375,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6499 6.375C7.6499 6.16789 7.8178 6 8.0249 6C8.23201 6 8.3999 6.16789 8.3999 6.375V9.625C8.3999 9.83211 8.23201 10 8.0249 10C7.8178 10 7.6499 9.83211 7.6499 9.625V6.375Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3999,
    y: 7,
    width: 0.75,
    height: 2,
    rx: 0.375,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappVoice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp_voice.394f61d0.svg";
export { ForwardRef as ReactComponent };